import { useState, useEffect } from 'react';
import { useGetDataSource } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSource';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { getToObjectType } from 'automation-ui-formula-editor/data-passing-panel/utils/getToObjectType';

//given a propertyValue object return the fromObjectId and toObjectId specified
export const useGetDataSourceFromToObjectIdFromPropertyValue = ({
  propertyValue,
  flowObjectTypeId
}) => {
  const [toObjectTypeId, setToObjectTypeId] = useState(flowObjectTypeId);
  const [loading, setLoading] = useState(true);
  const type = propertyValue.getType() || '';
  const dataToken = propertyValue.getPropertyToken() || '';
  const {
    prefix
  } = getTokenParts(dataToken);
  const {
    data,
    loading: queryLoading
  } = useGetDataSource({
    prefix
  });
  useEffect(() => {
    if (type === PropertyValueTypes.FETCHED_OBJECT_PROPERTY) {
      return;
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (type !== PropertyValueTypes.FETCHED_OBJECT_PROPERTY || !data || queryLoading) {
      return;
    }
    setToObjectTypeId(getToObjectType(data.dataSourceDefinition, flowObjectTypeId));
    setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryLoading, data]);
  return {
    fromObjectTypeId: flowObjectTypeId,
    toObjectTypeId,
    loading
  };
};